import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export function Dashboard() {
  const [memberStatus, setMemberStatus] = useState<{
    community_status?: string;
    coach_status?: string;
  }>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMemberStatus();
  }, []);

  const loadMemberStatus = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user?.id) {
        const { data, error } = await supabase
          .from('members')
          .select('community_status, coach_status')
          .eq('user_id', user.id)
          .single();
        
        if (!error && data) {
          setMemberStatus(data);
        }
      }
    } catch (error) {
      // Error loading member status
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">Loading...</div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Dashboard</h1>
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Welcome to the Skip Community!</h2>
        <div className="space-y-4 text-gray-600">
          <p>
            - Please <Link to="/profile" className="text-blue-600 hover:text-blue-800 underline">update your profile</Link>.
          </p>
          {memberStatus.community_status === 'active' && (
            <p>
              - All of our latest content and events are listed in the{' '}
              <a 
                href="https://docs.google.com/document/d/1DHQmyvfi5j1YjGNh-A4bfM__U0-C8qw2W2sYoV5PqPo/edit?tab=t.0#heading=h.4z9lqr9jg1d9" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:text-blue-800 underline"
              >
                Skip Community Directory
              </a>.
            </p>
          )}
        </div>
      </div>
      
      {/* Sentry Test Button - Remove in production */}
      {import.meta.env.MODE === 'development' && (
        <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <p className="text-sm text-yellow-800 mb-2">Sentry Test (Development Only)</p>
          <button 
            onClick={() => {throw new Error("This is your first error!");}}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            Break the world
          </button>
        </div>
      )}
    </div>
  );
}